import './css/styles.scss';


function initPausPlay() {
  let video = document.querySelector('video.wp-block-cover__video-background');
  let btn = document.getElementById('myButton');
  const icon = document.getElementById('playPauseCover');
  const playIcon = '/app/themes/engrateio/assets/img/play-icon-white.svg'; // The Play SVG
  const pauseIcon = '/app/themes/engrateio/assets/img/paus-icon-white.svg'; // The Pause SVG
  
if (!video || !btn) return;

  icon.src = pauseIcon;

  btn.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      icon.src = pauseIcon;
      //btn.innerHTML = 'Pause';
    } else {
      video.pause();
      icon.src = playIcon;
      //btn.innerHTML = 'Play';
    }
  });

  video.addEventListener('ended', function () {
    icon.src = playIcon;
  });
};

// on document ready
document.addEventListener('DOMContentLoaded', () => {
	initPausPlay();
});
